import styled from "styled-components";
import { Headline } from "../../Components/Text";

export const StyledHeadline = styled(Headline)`
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  transition: color 100ms ease;
`;
